































































































import {Component, Vue} from "vue-property-decorator";
import Email from "@/domainObjects/Email";
import AdminService from "@/services/AdminService";
import PlantPicker from "@/view/shared-components/PlantPicker.vue";
import alertMixin from "@/mixins/alert-mixin";
import Plant from "@/domainObjects/Plant";
import Fields from "@/domainObjects/Fields";
import TicketService from "@/services/TicketService";
import index from "@/store";
import ManageEmailSubscriptions from "@/view/admin/components/ManageEmailSubscriptions.vue";

@Component({
    components: {ManageEmailSubscriptions, PlantPicker},
    mixins: [alertMixin]
})
export default class ManageEmailPage extends Vue {
    private emailList: Email[] = [];
    private emailListFilteredByPlant: Email[] = [];
    private fields: Fields[] = [];
    private currentPage: number;
    private perPage: number;
    private totalRows: number;
    private filter: string;
    private hover: boolean;
    private pageOptions: number[];
    private sortDirection: string;
    private sortBy: null;
    private sortDesc: null;
    private isBusy = true;
    private plant!: Plant;
    private tableLayout: boolean = false;
    private show: boolean = true;
    $_alertMixin_deleteSuccess!: () => void;
    $_alertMixin_swalConfirm!: (heading: string | null, message: string | null, type: string | null) => Promise<boolean>;



    constructor(){
        super();
        this.fields = [
            { key: 'email', label: 'Email', sortable: true, sortDirection: 'desc' },
            { key: 'firstName', label: 'First Name', sortable: true, sortDirection: 'desc' },
            { key: 'lastName', label: 'Last Name', sortable: true, sortDirection: 'desc' },
            { key: 'plant.desc', label: 'Plant', sortable: true, sortDirection: 'desc' },
            { key: 'actions', label: 'Options', sortable: false, sortDirection: 'desc' },
        ];
        this.currentPage = 1;
        this.perPage = 25;
        this.totalRows = this.emailList.length;
        this.filter = "";
        this.hover = true;
        this.pageOptions = [ 5, 10, 25, 50, 100 ];
        this.sortDirection = 'asc';
        this.sortBy = null;
        this.sortDesc = null;
    }

    beforeMount(){
        this.getEmailList()
        this.plant = new Plant();
        this.plant.code = '0';
        this.plant.desc = 'All';
    }

    getEmailList(){
        this.isBusy = true;
        AdminService.getAllEmails().then((response)=>{
            for ( let readEmail of response.data ) {
                let email = new Email();
                readEmail.loaded = true;
                email.initFromObject(readEmail);
                this.emailList.push(email);
            }
            this.emailListFilteredByPlant = this.emailList;
            this.isBusy = false;
        }).catch((error)=>{
            this.isBusy = false;
        });
    }

    addEmail(){
        this.filter = "";
        const newEmail = new Email();
        newEmail.edit = true;
        newEmail.loaded = true;
        newEmail.plant = this.plant;
        this.emailList.unshift(newEmail);
        this.filterByPlant(this.plant.code)
    }

    createEmail(email: Email){
        email.subscribeFlag = Email.SUBSCRIPTIONS_ALL;
        if (
            this.validEmail(email.email) &&
            this.uniqueEmailPlant(email.email, email.plant.code) &&
            email.firstName.length > 0 &&
            email.lastName.length > 0 &&
            email.plant.code
        ){
            AdminService.createEmail(email).then((response)=>{
                if (response.data === 'success'){
                    email.edit = false;
                    this.show = false;
                    this.$nextTick(() => {
                        this.show = true;
                    });
                }
            }).catch((error)=>{
            })
        }
    }

    cancelCreateEmail(index){
        if (this.plant.code == '0') {
            this.emailList.splice(index, 1)
        } else {
            this.emailListFilteredByPlant.splice(index,1)
            this.emailList.splice(index,1);
        }
    }

    deleteEmail(item: Email){
        let self = this;
        this.$_alertMixin_swalConfirm('Delete Email?', item.email, 'warning').then((value) => {
            if (value) {
                AdminService.deleteEmail(item).then((response)=>{
                    if(response.data === 'success'){
                        this.emailList = this.emailList.filter(list => list !== item);
                        this.filterByPlant(null);
                        this.$_alertMixin_deleteSuccess();
                    }
                    else {
                        alert("error")
                    }
                }).catch((error)=> {
                });
            }
        })
    }

    validEmail(email) {
        // regex possibly slowly down browser after ~25 characters?
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
        {
            return true;
        }
        alert("You have entered an invalid email address!")
        return false;
    }

    uniqueEmailPlant(email, plantCode){
        for (let i = 0;i < this.emailList.length; i++){
            if (!this.emailList[i].edit){
                if (email === this.emailList[i].email && plantCode === this.emailList[i].plant.code){
                    alert('Email already added for this plant');
                    return false;
                }
            }
        }
        return true;
    }

    allRowsSaved(){
        let i = 0;
        for (let email of this.emailListFilteredByPlant){
            if (!email.edit) i++
        }
        if (this.emailListFilteredByPlant.length === i) return true;
    }

    toggleBusy() {
        this.isBusy = !this.isBusy;
    }

    onFiltered( filteredItems ) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
    }

    filterByPlant(value){
        if (value && value.code) this.plant = value;
        if (this.plant.code == '0'){
            this.emailListFilteredByPlant = this.emailList;
        } else {
            this.emailListFilteredByPlant = this.emailList.filter(email => email.plant.code === this.plant.code);
        }
    }
    selectPlant(value) {
        this.emailList[0].plant = value;
    }
}
